import { makeStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles((theme) => ({
    driverDetailWrapper: {
        display: 'flex',
        flexDirection: 'row',
        marginBottom: 32,
    },
    colorLocationCircle: {
        color: "rgb(255,214,67)",
    },
    locationLabelCircle: {
        width: "18px",
        margin: "-5px 5px 0 0",
    },
    driverLocation: {
        fontSize: 12,
        fontWeight: 700,
        marginBottom: 4
    },
    stateDate: {
        color: 'rgb(175, 179, 187)',
        marginBottom: 4,
        fontSize: 10,
    },
    dividerContainer: {
        width: '100%',
        margin: '16px 0px'
    },
    driverDistance: {
        fontSize: 12,
        fontWeight: 700,
        marginBottom: 4
    },
    eventsContainer: {
        display: 'flex',
        alignItems: 'right',
        justifyContent: 'center',
        flexDirection: 'row'
    },
    avgSpeedWrapper: {

    },
    avgSpeed: {},
    leftDrawerContainerButtonIcon: {
        margin: '3px 0 3px 10px'
    },
    cardWrapper: {
        borderRadius: theme.typography.pxToRem(15),
        overflow: 'hidden',
        maxWidth: theme.typography.pxToRem(330),
        minWidth: theme.typography.pxToRem(300),
        maxHeight: 'calc(100vh - 187px)',
        overflowY: 'auto',
    },
    backButtonTextContainerBox: {
        padding: theme.spacing(0, 0, 0, 0)
    },
    backIcon: {
        color: "black",
    },
    backIconText: {
        color: "black",
        fontWeight: 700,
        fontSize: theme.typography.pxToRem(15),
    },
    tripItem: {
        padding: theme.spacing(0, 3, 0, 3),
    },
    viewLessOrMoreItem: {
        padding: theme.spacing(0, 0, 1, 0),
        cursor: "pointer",
        textAlign: "center"
    },
    viewLessOrMoreWrapper: {
        padding: theme.spacing(0.3, 0, 0.5, 1),
    },
    tripItemSelected: {
        backgroundColor: 'rgba(255,212,40,.10)'
    },
    tripItemRow: {
        display: 'flex',
        marginTop: '5px',
    },
    tripItemRowCenter: {
        alignItems: 'center'
    },
    tripItemIconBox: {
        marginTop: theme.typography.pxToRem(2)
    },
    tripItemIconStart: {
        width: theme.typography.pxToRem(12),
        height: theme.typography.pxToRem(12),
        background: 'rgb(255,214,67)',
        borderRadius: theme.typography.pxToRem(12),
    },
    tripItemIconEnd: {
        width: theme.typography.pxToRem(12),
        height: theme.typography.pxToRem(12),
        background: 'rgb(255,214,67)'
    },
    dottedLine: {
        borderLeft: '2.7px dashed',
        borderColor: 'rgb(255, 211, 40)',
        marginLeft: '4.66px',
        marginTop: '3px',
        height: '75%',
    },
    tripItemSideBox: {
        padding: theme.spacing(0, 0, 1, 1),
    },
    eventAddress: {
        fontSize: theme.typography.pxToRem(12),
        fontWeight: 700,
        color: 'black',
    },
    eventNoAddress: {
        fontSize: theme.typography.pxToRem(12),
        fontWeight: 700,
        color: 'rgb(177,177,177)'
    },
    eventDate: {
        fontSize: theme.typography.pxToRem(10),
        color: 'rgb(177,177,177)',
        padding: theme.spacing(0.6, 0, 0, 0)
    },
    dividerClass: {
        margin: theme.spacing(0, 2, 0, 2)
    },
    stateBoxContainer: {
        padding: theme.spacing(0.5, 0, 0.5, 0),
        alignContent: "center",
    },
    stateBoxContainerItem: {
        flex: "1",
        padding: theme.spacing(1, 2, 1, 2)
    },
    stateTitle: {
        fontSize: theme.typography.pxToRem(10),
        color: 'rgb(177,177,177)'
    },
    stateValue: {
        fontSize: theme.typography.pxToRem(12),
        color: 'rgb(0,0,0)'
    },
    eventBox: {
        padding: theme.spacing(1.5, 0, 1, 1)
    },
    eventsIcon: {
        height: theme.typography.pxToRem(30),
        width: theme.typography.pxToRem(30),
    },
    webfleetIcon: {
        height: theme.typography.pxToRem(19),
        width: theme.typography.pxToRem(63),
    },
    eventValue: {
        margin: theme.spacing(0, 0, 0, 2),
        fontSize: theme.typography.pxToRem(20),
        fontWeight: 500
    },
    otherKeyValuesWrapper: {
        padding: theme.spacing(1.5, 0, 0.5, 1),
    },
    otherKey: {
        fontSize: theme.typography.pxToRem(10),
        color: 'rgb(177,177,177)',
        padding: theme.spacing(0.6, 0, 0, 0)
    },
    viewLessOrMore: {
        fontSize: theme.typography.pxToRem(12),
        color: 'rgb(23, 132, 255)',
        padding: theme.spacing(0.6, 0, 0, 0)
    },
    otherValue: {
        fontSize: theme.typography.pxToRem(12),
        fontWeight: 700
    },
    dateItem: {
        padding: theme.spacing(0, 3, 1.25, 0),
    },
    iconContainer: {
        padding: theme.spacing(0, 3, 1.25, 0),
    },
    tripDetailsContainer: {
        // padding: theme.spacing(0, 0, 1.25, 0),
    },
    callBtText: {
        fontSize: theme.typography.pxToRem(10),
        color: 'rgb(0,0,0)',
        padding: theme.spacing(3, 0, 0.5, 0),
        fontWeight: 300,
    },
    eventCardExpandButton: {
        position: 'absolute',
        right: '0',
        top: '0',
        zIndex: 1,
        cursor: 'pointer',
    },
    subEventDescription: {
        fontSize: theme.typography.pxToRem(10),
        paddingLeft: '10px'
    },
    mapIcon: {
        width: "12pt",
        position: 'absolute',
        right: '0',
        marginRight: '26pt',
        marginTop: '-5px'

    },
    eventDetailsBox: {
        textAlign: "center",
        margin: "16px"
    },
    eventDetailsLink: {
        color: theme.palette.primary.contrastText,
        textDecoration: "none"
    }
}));


